/** @deprecated Use button type from Skapa instead. */
var ButtonTypeEnum;
(function (ButtonTypeEnum) {
    ButtonTypeEnum["primary"] = "primary";
    ButtonTypeEnum["emphasised"] = "emphasised";
    ButtonTypeEnum["secondary"] = "secondary";
    ButtonTypeEnum["tertiary"] = "tertiary";
    ButtonTypeEnum["danger"] = "danger";
    ButtonTypeEnum["imageOverlay"] = "imageOverlay";
})(ButtonTypeEnum || (ButtonTypeEnum = {}));
export default ButtonTypeEnum;
//# sourceMappingURL=ButtonTypeEnum.js.map